import { Components, Theme } from "@mui/material";

export const PopoverStyle = (
  theme: Theme
): Pick<Components, "MuiPopover" | "MuiDivider"> => {
  return {
    MuiPopover: {
      styleOverrides: {
        root: {
          // ".MuiBackdrop-root": {
          //   background: "rgba(0, 0, 0, 0.2)",
          // },
        },
        paper: {
          backgroundColor: "transparent",
          boxShadow: "none",
        },
      },
    },

    MuiDivider: {
      styleOverrides: {
        root: {
          borderColor: "rgba(255, 255, 255, 0.12)",
        },
      },
    },
  };
};
